module.exports = __webpack_public_path__ + "img/faq_en.c931ba5.jpg";